<script>
    import urValidatorMixin from '../../../mixins/urValidator/urValidatorMixin.vue';

    export default {
        name: 'ur-validator',
        props: {
            value: [String,Number,Boolean,Array,Object,Date,Function],
            successMessage: {
                type: String
            },
            guideMessage: {
                type: String
            }
            /* [FROM VALIDATOR] */
            // rules
            // disabled
            // lazy
            // noShake
            /********************/
        },

        mixins: [urValidatorMixin],
        data() {return {
            /* [FROM VALIDATOR] */
            // hasError
            // errorMessage
            // showValid
            // shake
            /********************/
        }},
        computed: {
            /* [FROM VALIDATOR] */
            // isValidatable
            // el
            validateTarget() {return this.value;}, // validation setting
            /********************/
            messageShow() {
                if(this.hasError === undefined) {
                    return this.guideMessage;
                }
                if (this.hasError === true) {
                    return this.errorMessage;
                }
                if (this.hasError === false) {
                    return this.successMessage || this.guideMessage;
                }
                return undefined;
            },
            validatorClass() {
                let clazz = [];
                if(this.messageShow) {clazz.push('ur-validator--has-message')}
                if(this.hasError === true) {clazz.push('ur-validator--error')}
                if(this.showValid && this.hasError === false) {clazz.push('ur-validator--valid')}
                if(this.shake) {clazz.push('ur-validator--shake')}
                return clazz;
            }
        },
        watch: {
            successMessage: {
                immediate: true,
                handler(val) {
                    this.showValid = !!val;
                }
            },
        },
        mounted() {
        },
        methods: {
            /* [FROM VALIDATOR] */
            // validate()        --+
            // isValid()         --+-- exposed methods for manual validate control
            // clearValidation() --+
            // validateOnEvent() -> should be set by each component which uses urValidatorMixin
            /********************/
        },
        render() {
            return this.$scopedSlots.default({
                // methods
                validate: this.validate,
                validateOnEvent: this.validateOnEvent,
                isValid: this.isValid,
                clearValidation: this.clearValidation,

                // variables
                hasError: this.hasError,
                messageShow: this.messageShow,
                validatorClass: this.validatorClass,
                disabled: this.disabled
            });
        }
    }
</script>
